export default __webpack_public_path__ + "static/media/blog-img102.2c6cad15.jpg";